import { GreenhouseDepartment } from "../types";

const filterByLocation = (selectedLocationName: string) => (department: GreenhouseDepartment) => {
  if (selectedLocationName === "") {
    return true;
  }

  return department.jobs.some(
    (job) =>
      job?.location?.name?.trim().includes(selectedLocationName) ??
      job?.location?.name?.trim().includes("All Locations")
  );
};

export { filterByLocation };
